function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#5B6572",
  fillRule: "nonzero",
  stroke: "#5B6572",
  strokeWidth: .3
}, React.createElement("path", {
  d: "M5.68 9.355c1.106 0 2.005-.864 2.005-1.927 0-1.063-.9-1.928-2.005-1.928-1.106 0-2.005.865-2.005 1.928s.9 1.927 2.005 1.927zm0-3.163c.708 0 1.285.555 1.285 1.236 0 .68-.577 1.235-1.285 1.235S4.395 8.11 4.395 7.428c0-.68.577-1.236 1.285-1.236z"
}), React.createElement("path", {
  d: "M1 1v18h18V1H1zm.72.692h16.56v9.252l-3.717-3.276a.367.367 0 0 0-.509.022l-3.526 3.713-1.707-1.642a.37.37 0 0 0-.492-.015l-6.025 5.1H1.72V1.692zm16.56 16.616H1.72v-2.77h16.56v2.77zM3.394 14.846l5.156-4.365 3.709 3.566a.37.37 0 0 0 .509 0 .336.336 0 0 0 0-.49l-1.73-1.664 3.305-3.48 3.937 3.47v2.963H3.394z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _ref);

export default __webpack_public_path__ + "static/media/image-post-filter.e1057c79.svg";
export { SvgComponent as ReactComponent };